'use client';

import { useEffect } from 'react';

interface DatadogRumOptions {
    loaded: boolean;
    ddenv: string;
    pageInfo: {
        analyticsPageName: string;
        analyticsPageType: string;
        pageType: PageType;
    };
}

/** Initialize the script-provided SDK under the existing collection policy. */
export function useDatadogRum({ loaded, ...props }: DatadogRumOptions): void {
    useEffect(() => {
        const browserWindow = window as BrowserWindow;

        if (browserWindow.DD_RUM && process.env.NODE_ENV === 'production') {
            browserWindow.DD_RUM.init({
                clientToken: 'pub2efebd86de973d3161e20023ac07e68a',
                applicationId: 'c27edd08-fd30-4d05-ace8-21ad46980f08',
                site: 'datadoghq.com',
                service: 'sxm-cecm-web-www',
                env: props.ddenv,
                version: browserWindow.document.documentElement.dataset.ddVersion || '1.0.0',
                sessionSampleRate: 45,
                sessionReplaySampleRate: 20,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: 'mask-user-input',
            });

            browserWindow.DD_RUM.startSessionReplayRecording();
            browserWindow.DD_RUM.setGlobalContext(props.pageInfo);
        }
    }, [loaded, props.ddenv, props.pageInfo]);
}
